export const ACS_FORMS = [
  {
    "key": "CustomerLeaseForm",
    "title": "Customer lease",
    "fields": [
      {
        "key": "monthly_fee",
        "label": "Monthly Fee ($)",
        "initial": "49.00"
      },
      {
        "key": "insurance_fee",
        "label": "Insurance Fee ($)",
        "initial": "7.50"
      },
      {
        "key": "monitoring_fee",
        "label": "Monitoring Fee ($)",
        "initial": "10.00"
      },
      {
        "key": "installation_fee",
        "label": "Installation Fee ($)",
        "initial": "100.00"
      },
      {
        "key": "damage_deductible",
        "label": "Damage Deductible ($)",
        "initial": "250.00"
      },
      {
        "key": "system_value",
        "label": "System Value ($)",
        "initial": "1500.00"
      },
      {
        "key": "filing_charge",
        "label": "Filing Charge ($)",
        "initial": "15.00"
      },
      {
        "key": "late_fee",
        "label": "Late Fee ($)",
        "initial": "15.00"
      },
      {
        "key": "late_fee_percentage",
        "label": "Late Fee (%)",
        "initial": "1.50"
      },
      {
        "key": "sales_tax_percentage",
        "label": "Sales Tax (%)",
        "initial": "0.00"
      },
      {
        "key": "first_payment_amount",
        "label": "First Payment Amount ($)",
        "initial": "70.30"
      },
      {
        "key": "total_contract_amount",
        "label": "Total Contract Amount ($)",
        "initial": "70.30"
      }
    ],
    "checklist": [],
    "endpoint": "https://alcobrakeadmin.com/v3/alcobrake/insertupdatecustomerleaseagreement",
    "preview": "https://alcobrakeadmin.com/v3/alcobrake/customerleaseagreement"
  },
  {
    "key": "ServiceProviderForm",
    "title": "Service provider",
    "fields": [
      {
        "key": "device_installation",
        "label": "Device Installation ($)",
        "initial": "100.00"
      },
      {
        "key": "program_enrollment",
        "label": "Program Enrollment ($)",
        "initial": "25.00"
      },
      {
        "key": "monthly_lease",
        "label": "Monthly Lease ($)",
        "initial": "99.00"
      },
      {
        "key": "monthly_late_fee",
        "label": "Monthly Late Fee ($)",
        "initial": "25.00"
      },
      {
        "key": "additional_monitoring",
        "label": "Additional Monitoring ($)",
        "initial": "10.00"
      },
      {
        "key": "recalibration_lockout",
        "label": "Recalibration Lockout ($)",
        "initial": "0.00"
      },
      {
        "key": "recalibration_after_final_day",
        "label": "Recalibration After Final Day ($)",
        "initial": "50.00"
      },
      {
        "key": "violation_lockout",
        "label": "Violation Lockout ($)",
        "initial": "50.00"
      },
      {
        "key": "violation_after_final_day",
        "label": "Violation After Final Day ($)",
        "initial": "100.00"
      },
      {
        "key": "missed_service_appointment",
        "label": "Missed Service Appointment ($)",
        "initial": "25.00"
      },
      {
        "key": "vehicle_exchange",
        "label": "Vehicle Exchange ($)",
        "initial": "200.00"
      },
      {
        "key": "device_removal",
        "label": "Device Removal ($)",
        "initial": "100.00"
      },
      {
        "key": "troubleshooting_replacement",
        "label": "Troubleshooting / Replacement ($)",
        "initial": "50.00"
      },
      {
        "key": "tampering_circumvention",
        "label": "Tampering / Circumvention ($)",
        "initial": "100.00"
      }
    ],
    "checklist": [],
    "endpoint": "https://alcobrakeadmin.com/v3/alcobrake/insertupdateserviceprovider",
    "preview": "https://alcobrakeadmin.com/v3/alcobrake/serviceprovider"
  },
  {
    "key": "StandardFeeForm",
    "title": "Standard fee",
    "fields": [
      {
        "key": "basic_installation",
        "label": "Basic Installation ($)",
        "initial": "0.00"
      },
      {
        "key": "premium_installation",
        "label": "Premium Installation ($)",
        "initial": "0.00"
      },
      {
        "key": "premium_plus_installation",
        "label": "Premium Plus Installation ($)",
        "initial": "0.00"
      },
      {
        "key": "calibration_days",
        "label": "Calibration Days ($)",
        "initial": "0.00"
      },
      {
        "key": "missed_appointment",
        "label": "Missed Appointment ($)",
        "initial": "0.00"
      },
      {
        "key": "removal_tier_1",
        "label": "Removal Tier 1 ($)",
        "initial": "0.00"
      },
      {
        "key": "removal_tier_2",
        "label": "Removal Tier 2 ($)",
        "initial": "0.00"
      },
      {
        "key": "removal_tier_3",
        "label": "Removal Tier 3 ($)",
        "initial": "0.00"
      },
      {
        "key": "mobile_installation",
        "label": "Mobile Installation ($)",
        "initial": "0.00"
      },
      {
        "key": "mobile_calibration_business_hours",
        "label": "Mobile Calibration - Business Hours ($)",
        "initial": "0.00"
      },
      {
        "key": "mobile_calibration_after_hours",
        "label": "Mobile Calibration - After Hours ($)",
        "initial": "0.00"
      },
      {
        "key": "lockout_service_center",
        "label": "Lockout - Service Center ($)",
        "initial": "0.00"
      },
      {
        "key": "lockout_after_5_days",
        "label": "Lockout After 5 Days ($)",
        "initial": "0.00"
      },
      {
        "key": "lockout_mobile_after_hours",
        "label": "Lockout Mobile After Hours ($)",
        "initial": "0.00"
      }
    ],
    "checklist": [],
    "endpoint": "https://alcobrakeadmin.com/v3/alcobrake/insertupdatestandardfee",
    "preview": "https://alcobrakeadmin.com/v3/alcobrake/standardfee"
  },
  {
    "key": "CustomerChecklistForm",
    "title": "Customer checklist",
    "fields": [],
    "checklist": [
      [
        "instruction_manual",
        "Instruction Manual"
      ],
      [
        "lease_agreement",
        "Lease Agreement"
      ],
      [
        "device_responsibility",
        "Device Responsibility"
      ],
      [
        "instructional_video",
        "Instructional Video"
      ],
      [
        "device_training",
        "Device Training"
      ],
      [
        "alcohol_detection",
        "Alcohol Detection"
      ],
      [
        "failed_test_wait",
        "Failed Test / Wait Period"
      ],
      [
        "rolling_retest",
        "Rolling Retest"
      ],
      [
        "retest_violation_lockout",
        "Retest Violation / Lockout"
      ],
      [
        "bypass_violation",
        "Bypass Violation"
      ],
      [
        "calibration_requirement",
        "Calibration Requirement"
      ],
      [
        "all_vehicle_requirement",
        "All Vehicle Requirement"
      ],
      [
        "other_person_blowing",
        "Other Person Blowing"
      ],
      [
        "tamper_circumvention",
        "Tamper / Circumvention"
      ],
      [
        "vehicle_operation",
        "Vehicle Operation"
      ],
      [
        "drink_drive_responsibility",
        "Drink / Drive Responsibility"
      ],
      [
        "non_compliance",
        "Non Compliance"
      ]
    ],
    "endpoint": "https://alcobrakeadmin.com/v3/alcobrake/insertupdatecustomerchecklist",
    "preview": "https://alcobrakeadmin.com/v3/alcobrake/customerchecklist"
  },
  {
    "key": "InstallationServiceChecklist",
    "title": "Installer checklist",
    "fields": [],
    "checklist": [
      [
        "wait_for_drive_safely",
        "Wait Until Safe to Drive"
      ],
      [
        "rolling_test_required",
        "Rolling Test Required"
      ],
      [
        "service_appointment_required",
        "Service Appointment Required"
      ],
      [
        "reconnect_handset",
        "Reconnect Handset"
      ],
      [
        "calibration_60_days",
        "Calibration Every 60 Days"
      ],
      [
        "dui_school_requirement",
        "DUI School Requirement"
      ],
      [
        "mechanic_instruction",
        "Mechanic Instruction"
      ],
      [
        "lockout_reset_fee",
        "Lockout Reset Fee"
      ],
      [
        "handset_sensor_shade",
        "Handset / Sensor Shade"
      ]
    ],
    "endpoint": "https://alcobrakeadmin.com/v3/alcobrake/insertupdateinstallationservicechecklist",
    "preview": "https://alcobrakeadmin.com/v3/alcobrake/installationchecklist"
  }
];
